export default __webpack_public_path__ + "static/media/navy-online-payments.3c9fc585.svg";